import React, { useEffect, useState, useRef } from 'react'
import AccountManagementTable from '../../components/Table/Table'
import AccountManagementModal from './AccountManagementModal'
import ConfirmModal from '../../components/Modals/ConfirmModal'
import API from '../../utils/API'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import constants from '../../utils/constants'
import tableCheckbox from '../../components/Inputs/tableCheckbox'
import { FormattedMessage } from 'react-intl';
import useInfiniteScroll from '../../components/common/useInfiniteScroll';
import editIcon from '../../assets/icons/table/edit.svg'
import trashIcon from '../../assets/icons/table/trash.svg'

function AccountManagement(props) {
  const navigate = useNavigate();
  const { user } = props;
  const permissionIds = user.permissions.map((permission)=>{
    return permission.id
  })

  useEffect(() => {
    console.log('hello')
    if(!permissionIds.includes(constants.permissionIds.editHwWarranty) && !permissionIds.includes(constants.permissionIds.hwWarrantyRead)){
      navigate('/forbidden');
    };
  }, [navigate, permissionIds])

  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [selectedAccount, setSelectedAccount] = useState(null);

  const [dataLoaded, setDataLoaded] = useState(false);
  // Track the type of action to perform on the user
  const [actionType, setActionType] = useState('');

  // Give state to all components of the dataMap(explained later) you want to render
  const [data, setData] = React.useState([]);
  const [dataCount, setDataCount] = React.useState(0);
  const [totalDataCount, setTotalDataCount] = React.useState(0);
  const [selectedIds, setSelectedIds] = React.useState({});
  const [sortByCol, setSortByCol] = React.useState('companyName');
  const [sortByAsc, setSortByAsc] = React.useState(true);
  const [startIndexForTable, setStartIndexForTable] = React.useState(0);

  const [showRegModal, setShowRegModal] = useState(false)

  const registrationRef = useRef();
  const tableRef = useRef();
  const tableWrapperRef = useRef();

  // Function to reset Registration.js fields
  const resetRegistrationFields = () => {
    registrationRef.current.resetFields();
  };

  const dataMap = React.useMemo(
    () => {
      const map = {data: {}, ids: [], selectedIds: {}, filteredIds: []};
      loadTable(map);
      return map;
    }
  , [])

  const { generateDataSlice, sortMap, setSortBy } = useInfiniteScroll({
    dataMap,
    setData,
    setStartIndexForTable,
    startIndexForTable,
    pageSize: 100, 
    sortByCol,
    setSortByCol,
    sortByAsc, 
    setSortByAsc,
    tableWrapperRef,
    searchValue,
    tableRef,
  });
    
  function loadTable(map, resetSelection=true) {
    //Reset map
    map.data = {};
    map.ids = [];
    map.sortedIds = [];
    map.filteredIds = [];
    if(resetSelection){
      map.selectedIds = {}
    }

    API.getAccounts().then((res)=>{
      res.data.forEach((account)=>{

        // Display status as Activated or Not Activated based on status value
        const statusDisplay = account.status === 1 ? 'Activated' : 'Not Activated';

        map.data[account.id] = {
          id: account.id,
          userId: account.user_id,
          firstName: account.first_name,
          lastName: account.last_name,
          companyName: account.company_name,
          companyPhone: account.phone,
          phone: account.user_phone,
          address: account.address,
          website: account.website,
          email: account.email,
          statusDisplay,
          checked: false,
        }
      })
      map.filteredIds = Object.keys(map.data);
      map.ids = Object.keys(map.data);
      // Call React setState to render a section of our data
      if(searchValue !== "") {
        tableRef.current.search(map)
      } else {
        sortMap(map);
        setData(generateDataSlice(map));
        setDataCount(map.sortedIds.length);
      }   
      setSelectedIds(map.selectedIds);
      setTotalDataCount(map.ids.length);
      setDataLoaded(true);
    })
  }

  /**
   * Closes modal given the modal id
   * @param {*} modalId - id of modal to close
   */
  function closeModal(modalId) {
    console.log('closingModal', modalId);
    const modal = document.getElementById(modalId);
    if (modal) {
      const closeButton = modal.querySelector('.btn-close');
      if (closeButton) {
        closeButton.click();
      }
    }
    if(modalId === 'createAccountModal') loadTable(dataMap, false);
  }

  // Initialize refs for modal reset functions
  const resetAccountModalRef = useRef(null);

  const handleResetAccountModal = () => {
    if (resetAccountModalRef.current) {
      resetAccountModalRef.current();
    }
  };

  /**
   * Handle edit click on account table
   * @param {*} id 
   */
  function handleEditClick(e, id) {
    e.preventDefault();
    const clickedAccount = dataMap.data[id];
    console.log('clicked account', clickedAccount)
    setSelectedAccount(dataMap.data[id]);
  }

  /**
   * Handle click to delete a specific account.
   * @param {string} id 
   */
  function handleSingleDelete(e, id) {
    e.preventDefault();
    let clickedAccount = dataMap.data[id];
    console.log('deleting clicked account:', clickedAccount);
    setSelectedAccount(clickedAccount);
    setActionType('single');
  }

  /**
   * Handle click mass delete action.
   */
  function handleMassDelete(e) {
    e.preventDefault();
    setActionType('multiple');
  }

  const handleDeleteAccount = async () => {
    setSuccess('');
    setError('');
  
    try {
      if (actionType === 'single') {
        console.log('deleting single account:', selectedAccount);
        // Single delete: send the selected account ID as an array
        if (selectedAccount) {
          await API.deleteAccount([selectedAccount.id]); // Pass the account ID in an array
          setSuccess(<FormattedMessage id="DELETE_ACCOUNT_SUCCESS" />);
        } else {
          setError(<FormattedMessage id="DELETE_ACCOUNT_FAILED" />);
        }
      } else {
        // console.log('deleting multiple accounts:', selectedIds);
        const idsToDelete = Object.keys(selectedIds).filter((id) => selectedIds[id]);
        console.log('deleting multiple accounts:', idsToDelete);
        await API.deleteAccount(idsToDelete); // Pass an array of account IDs
  
        setSuccess(
          <FormattedMessage
            id="COUNT_ACCOUNTS_DELETED_SUCCESS"
            values={{ count: idsToDelete.length }}
          />
        );
      }
  
      closeModal('confirmModal');
    } catch (err) {
      setError(
        <FormattedMessage
          id="DELETE_ACCOUNT_FAILED"
          values={{ errorMsg: <b>{err.message}</b> }}
        />
      );
    }
  
    loadTable(dataMap);
  };
  

  // Initialize table columns
  const tableColumnArray = [
    {
      Header: tableCheckbox,
      id: 'checkbox',
      accessor: 'checked',
      Cell: tableCheckbox,
      isVisible: true,
      width: 63,
      maxWidth: 63,
    },
    {
      Header: 'COMPANY_NAME',  
      id: 'companyName',  
      accessor: 'companyName',  
      isVisible: true,  
    },
    {
      Header: 'ID',
      id: 'id',
      accessor: 'id',
      isVisible: true,
    },
    {
      Header: 'ACCOUNT_OWNER',  
      id: 'email',  
      accessor: 'email',  
      isVisible: true,  
    },
    {
      Header: "STATUS",
      id: 'status',
      accessor: 'statusDisplay', 
      isVisible: true,
      Cell: ({ value }) => (
        <div style={{ color: value === 'Activated' ? "green" : "gray" }}>
          <FormattedMessage id={value === 'Activated' ? 'ACTIVATED' : 'NOT_ACTIVATED'} defaultMessage={value} />
        </div>
      ),
    },
    {
      Header: '',
      id: 'actions',
      isVisible: true,
      Cell: ({ row }) => (
        <div className="actions">
          <button
            className="btn"
            id="editAccountAction"
            data-bs-toggle="modal"
            data-bs-target={`#editAccountModal`}
            onClick={(e) => {
              e.stopPropagation(); // Prevent click from propagating to the parent cell
              if (handleEditClick) handleEditClick(e, row.original.id);
            }}
          >
            <img src={editIcon} className="actionIcon editAction" alt={<FormattedMessage id="EDIT" />} />
          </button>
          <button
            className="btn delete-action"
            id="deleteAccountAction"
            data-bs-toggle="modal"
            data-bs-target={`#confirmModal`}
            onClick={(e) => {
              e.stopPropagation(); // Prevent click from propagating to the parent cell
              if (handleSingleDelete) handleSingleDelete(e, row.original.id);
            }}
          >
            <img src={trashIcon} className="actionIcon deleteAction" alt={<FormattedMessage id="DELETE" />} />
          </button>
        </div>
      ),
    }
  ]

  const tableColumns = React.useMemo(
  
  () => tableColumnArray, [])

  const buttons = {
    toolbarRightButtons: (
      <button 
        type="button" 
        className="btn btn-unfilled"
        id="addAccountBtn" 
        onClick={resetRegistrationFields}
        data-bs-toggle="modal"
        data-bs-target={`#createAccountModal`}
      >
        <FormattedMessage id="ADD_ACCOUNT" defaultMessage="Add Account" />
      </button>
    ),
    footerButtons: (
      <button 
        type="button" 
        className="btn deleteBtn"
        id="deleteAccountBtn"
        disabled={Object.keys(selectedIds).length === 0}
        data-bs-toggle="modal"
        data-bs-target={`#confirmModal`}
        onClick={handleMassDelete}
      >
        <FormattedMessage id="DELETE_ACCOUNT" defaultMessage="Delete Account" /> 
      </button>
    )
  }

  // Props to pass to our table 
    const tableProps = {
    pageType: constants.pageType.AccountManagement,
    modalId: 'editAccountModal',
    columns: tableColumns,
    // Data Handling props
    data, setData,
    dataMap,
    generateDataSlice,
    sortMap,
    dataCount, setDataCount,
    totalDataCount,
    // Sorting
    setSortBy,
    sortByCol,
    sortByAsc,
    // Error handling
    success, setSuccess,
    error, setError,
    // Common props
    buttons,
    startIndex: startIndexForTable,
    selectedIds, setSelectedIds,
    searchValue, 
    setSearchValue,
    tableRef,
    tableWrapperRef,
    dataLoaded,
    // Action column props
    handleEditClick,
    handleSingleDelete,
  }

  const confirmModalProps = {
    actionType,
    selectedItem: selectedAccount,
    checkedItems: Object.keys(selectedIds),
    handleDelete: handleDeleteAccount,
    closeModal,
    dataType: 'account(s)',
    warning: "DELETE_ACCOUNT_WARNING",
  }
  
  // Props to pass to our modal component
  const modalProps = {
    setResetAccountModalRef: (resetFunc) => { resetAccountModalRef.current = resetFunc; },
    setSuccess, setError,
    selectedAccount, setSelectedAccount,
    success, error,
    closeModal,
    showRegModal, setShowRegModal,
    registrationRef,
    loadTable, dataMap
  }

  return (
    <div>
      <AccountManagementModal registrationRef={registrationRef} {...modalProps} />
      <ConfirmModal {...confirmModalProps} />
      <AccountManagementTable {...tableProps} />
      {error ? (
        <div className="alert alert-danger"><FormattedMessage id="ERROR" />{error}</div>
      ) : null}
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(AccountManagement)